import { ResHandle, formatDate } from '@/utils/utils'
const state = {
  page: 1,
  total: 0,
  limit: 15,
  class_id: '',
  email: '',
  unit_name: '',
  username: '',
  real_name: '',
  is_activated: '',
  activateDate: [],
  createDate: [],
  activated_at_from: null,
  activated_at_to: null,
  created_at_from: null,
  created_at_to: null
}

const actions = {
  // student get data
  async studentManageGetData({ commit, state }, playload) {
    const unit_id = localStorage.getItem('role_id')
    const page = state.page
    if (unit_id === '40001') {
      const data = {
        class_id: state.class_id,
        created_at_from:
          state.created_at_from && formatDate(state.created_at_from, 'U'),
        created_at_to:
          state.created_at_to && formatDate(state.created_at_to, 'U'),
        is_activated: state.is_activated,
        name: state.real_name,
        unit_name: state.unit_name,
        activated_at_from:
          state.activated_at_from && formatDate(state.activated_at_from, 'U'),
        activated_at_to:
          state.activated_at_to && formatDate(state.activated_at_to, 'U')
        // unit_type_id: state.unit_type_id,
      }
      Object.keys(data).forEach(key => {
        if (!data[key] && key !== 'is_activated') {
          delete data[key]
        }
      })
      if (data['is_activated'] === 2 || data['is_activated'] === '') {
        delete data['is_activated']
      }
      const res = await API.get(
        `/edu/zone/channel/agent/students?page=${page}`,
        data
      )
      if (res.status < 400) {
        commit('setState', {
          module: 'studentManage',
          key: 'total',
          value: res.data.total
        })
      }
      return res
    } else {
      const data = {
        activated_at_from:
          state.activated_at_from && formatDate(state.activated_at_from, 'U'),
        activated_at_to:
          state.activated_at_to && formatDate(state.activated_at_to, 'U'),
        created_at_from:
          state.created_at_from && formatDate(state.created_at_from, 'U'),
        created_at_to:
          state.created_at_to && formatDate(state.created_at_to, 'U'),
        unit_type_id: state.unit_type_id,
        email: state.email,
        username: state.username,
        class_id: state.class_id,
        real_name: state.real_name,
        is_activated: state.is_activated
      }
      Object.keys(data).forEach(key => {
        if (!data[key] && key !== 'is_activated') {
          delete data[key]
        }
      })
      if (data['is_activated'] === 2 || data['is_activated'] === '') {
        delete data['is_activated']
      }
      const res = await API.get(`/edu/zone/students?page=${page}`, data)
      if (res.status < 400) {
        commit('setState', {
          module: 'studentManage',
          key: 'total',
          value: res.data.total
        })
      }
      return res
    }
  },
  // student edit name
  async studentManageEditName({ commit }, playload) {
    const res = await API.patch(`/edu/zone/students/${playload.id}`, {
      real_name: playload.real_name
    })
    return ResHandle(res)
  },
  // edit score
  async studentManageEditScore({ commit }, playload) {
    const res = await API.put(`/edu/zone/students/${playload.id}/score`, {
      score: playload.score
    })
    return ResHandle(res)
  },
  // 导出学生列表
  async studentManageExcel({ commit, state, rootState }) {
    const data = {
      activated_at_from:
        state.activated_at_from && formatDate(state.activated_at_from, 'U'),
      activated_at_to:
        state.activated_at_to &&
        formatDate(+new Date(state.created_at_to) / 1000 + 24 * 60 * 60, 'U'),
      created_at_from:
        state.created_at_from && formatDate(state.created_at_from, 'U'),
      created_at_to:
        state.created_at_to &&
        formatDate(+new Date(state.created_at_to) / 1000 + 24 * 60 * 60, 'U'),
      unit_type_id: state.unit_type_id,
      email: state.email,
      username: state.username,
      class_id: state.class_id,
      real_name: state.real_name,
      is_activated: state.is_activated,
      language: rootState.locale
    }
    Object.keys(data).forEach(key => {
      if (!data[key] && key !== 'is_activated') {
        delete data[key]
      }
    })
    if (data['is_activated'] === 2 || data['is_activated'] === '') {
      delete data['is_activated']
    }
    const res = await API.get('/edu/zone/students/excel', data, {
      responseType: 'arraybuffer'
    })
    return res
  },
  // 重置密码
  async studentManageResetPwd({ commit }, id) {
    const res = await API.patch(`/edu/zone/students/${id}/password`)
    return res
  }
}

const mutations = {
  studentManageInit(state) {
    state.class_id = ''
    state.email = ''
    state.username = ''
    state.real_name = ''
    state.is_activated = ''
    state.unit_name = ''
    state.activated_at_from = null
    state.activated_at_to = null
    state.created_at_from = null
    state.created_at_to = null
    state.page = 1
  }
}

export default {
  state,
  actions,
  mutations
}
